import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export class ColumnHeader extends React.Component {
  constructor(props) {
    super(props);
    const { currentTableSortField, dataField, sortDirection } = this.props;

    if (currentTableSortField === dataField) {
      this.state = ({ sortDirection });
    } else {
      // When the initial state is descending, the first click will sort the column in ascending order.
      this.state = ({ sortDirection: 'DESC' });
    }

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    if (this.props.sortFunc) {
      const newSortDirection = this.state.sortDirection === 'DESC' ? 'ASC' : 'DESC';
      this.props.handleClick(this.props.sortFunc, this.props.dataField, newSortDirection);
      this.setState({ sortDirection: newSortDirection });
    }
  }

  render() {
    const {
      currentTableSortField,
      name,
      sortFunc,
      dataField,
      hidden,
      sortable,
      formatted,
      className,
    } = this.props;

    let thClassName = '';
    if (sortable) {
      thClassName = currentTableSortField === dataField ? 'sort-column active' : 'sort-column';
    }
    thClassName = hidden ? 'hidden' : thClassName + className;

    const sortIconClassName = this.state.sortDirection === 'DESC'
      ? 'sort-handle fa-solid fa-chevron-down'
      : 'sort-handle fa-solid fa-chevron-up';
    const columnHeader = name ? (formatted ? name : <FormattedMessage { ...name } />) : null;

    return (
        <th className={ thClassName }
          onClick={ this.onClick }
        >
            { name && !hidden ? columnHeader : null }
            { sortable ? <span className={ sortIconClassName }></span> : null }
        </th>

    );
  }
}

ColumnHeader.propTypes = {
  className: PropTypes.string,
  dataField: PropTypes.string,
  sortable: PropTypes.bool,
  hidden: PropTypes.bool,
  formatted: PropTypes.bool,
  handleClick: PropTypes.func,
  sortFunc: PropTypes.func,
  name: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  currentTableSortField: PropTypes.string,
  sortDirection: PropTypes.oneOf(['ASC', 'DESC']),
};
